<template>
  <div class="gissty">
    <div class="maps" :class="supClickfigg==true?'mapsbox':''">
      <div class="mapa" id="mapa"></div>
    </div>
    <div class="mpaQuery">
      <el-select v-model="maQyeryval" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod"
        :loading="loading" @change="maplistChange">
        <el-option v-for="(item,i) in mapOptions" :key="i" :label="item.properties.NAME" :value="item.id">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      mapChliddata: null,
      mapClickstate: null,
      RmineBc: null,
      latlngs: null,
    },
    data() {
      return {
        // ditu: "http://10.4.128.181:8090/iserver/services/map-ugcv5-YuDiBaDiTu/rest/maps/淤地坝底图",
        // yls: "http://10.4.128.181:8090/iserver/services/map-YuDiBa/rest/maps/榆林市骨干坝",
        // data_yudiba: "http://10.4.128.181:8090/iserver/services/data-YuDiBa/rest/data",
        
        ditu: "http://119.3.176.240:8090/iserver/services/map-ugcv5-YuDiBaDiTu/rest/maps/淤地坝底图",
        yls: "http://119.3.176.240:8090/iserver/services/map-YuDiBa/rest/maps/榆林市骨干坝",
        data_yudiba: "http://119.3.176.240:8090/iserver/services/data-YuDiBa/rest/data",
        
        supClickfigg: false,
        latlngLayer: new L.layerGroup(),
        map: null,
        setViewlat: this.$store.state.setViewlat,
        setViewlng: this.$store.state.setViewlng,
        setViewcenter: this.$store.state.setViewcenter,
        marker: null,
        lngs: '',
        lats: '',
        maQyeryval: '',
        mapOptions: [],
        datalist: [],
        loading: false,
      }
    },
    cerate() {
      //初始化数据
    },
    methods: {
      maplistChange(val) {
        this.latlngLayer.clearLayers();
        let pulseIcon = L.icon({
          iconUrl: './images/marker-icon.png',
          iconSize: [30, 40]
        });
        for (let i = 0; i < this.mapOptions.length; i++) {
          if (val == this.mapOptions[i].id) {
            let latlng = {
              lat: Number(this.mapOptions[i].properties.LAT),
              lng: Number(this.mapOptions[i].properties.LON)
            };
            this.map.setView(latlng, 12);
            let marker = L.marker(latlng, {
              icon: pulseIcon
            });
            this.latlngLayer.addLayer(marker);
            this.latlngLayer.addTo(this.map);
            this.$emit("changeData", this.mapOptions[i]);
            this.$emit("changeZoom", this.map.getZoom());
          }
        }
      },
      remoteMethod(val) {
        if (val) {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.mapOptions = this.datalist.filter(item => {
              return item.properties.NAME.toLowerCase()
                .indexOf(val.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.mapOptions = []
        }
      },
      supGIS(latlng) {
        let _this = this;
        this.$nextTick(() => {
          this.map = L.map("mapa", {
            logoControl: false,
            attributionControl: false,
            zoomControl: false,
            center: [37.58, 110.325],
            zoom: 13,
            minZoom: 8,
            maxZoom: 18,
            crs: L.CRS.EPSG4326,
            maxBounds: [
              [3.59, 73.5],
              [53.57, 135.1]
            ],
            closePopupOnClick: false,
          });
          L.supermap.tiledMapLayer(this.ditu, {
            noWrap: true
          }).addTo(this.map);
          L.supermap.tiledMapLayer(this.yls, {
            noWrap: true
          }).addTo(this.map);
        });
      },
      supclick() {
        let _this = this;
        this.map.on("click", function(evt) {
          if (_this.supClickfigg == true) {
            let pulseIcon = L.icon({
              iconUrl: './images/marker-icon.png',
              iconSize: [30, 40]
            });
            _this.latlngLayer.clearLayers();
            _this.map.setView(evt.latlng);

            _this.marker = L.marker(evt.latlng, {
              icon: pulseIcon
            });
            _this.latlngLayer.addLayer(_this.marker);
            _this.latlngLayer.addTo(_this.map);
            _this.$emit("clickData", evt);
          }
        });
      },
      dataQuery() {
        let _this = this;
        let datasets = ["淤地坝:榆林市骨干坝资料"];
        let param = new SuperMap.GetFeaturesBySQLParameters({
          datasetNames: datasets,
          toIndex: 10000,
          maxFeatures: 10000,
          queryParameter: {
            attributeFilter: "SMID > 0"
          }
        });
        L.supermap.featureService(this.data_yudiba).getFeaturesBySQL(param, function(serviceResult) {
          // console.log(serviceResult.result.features.features)
          _this.datalist = serviceResult.result.features.features;
        });
      },
    },
    components: {

    },
    mounted() {
      this.supGIS();
      this.dataQuery();

      let _this = this;
      if (this.latlngs) {
        setTimeout(function() {
          let pulseIcon = L.icon({
            iconUrl: './images/marker-icon.png',
            iconSize: [30, 40]
          });
          _this.latlngLayer.clearLayers();
          _this.map.setView(_this.latlngs);

          let marker = L.marker(_this.latlngs, {
            icon: pulseIcon
          });
          _this.latlngLayer.addLayer(marker);
          _this.latlngLayer.addTo(_this.map);
        }, 200);
      }
    },
    watch: {
      RmineBc(a, b) {
        this.$emit("Rminebc", {
          'zoom': this.map.getZoom(),
          'latlngs': this.map.getCenter()
        });
      },
      mapChliddata(a, b) {
        let pulseIcon = L.icon({
          iconUrl: './images/marker-icon.png',
          iconSize: [30, 40]
        });
        if (a == null) {
          this.latlngLayer.clearLayers();
          this.map.setView(this.$store.state.setViewlat, this.$store.state.setViewlng, this.$store.state.setViewcenter);
        } else {
          let latlngs = a;
          this.lats = latlngs.lat;
          this.latlngLayer.clearLayers();
          if (latlngs.zoom) {
            this.map.setView(latlngs, latlngs.zoom);
          } else {
            this.map.setView(latlngs);
          }
          let marker = L.marker(latlngs, {
            icon: pulseIcon
          });
          this.latlngLayer.addLayer(marker);
          this.latlngLayer.addTo(this.map);
        }
      },
      mapClickstate(a, b) {
        this.supClickfigg = a;
        if (this.supClickfigg == true) {
          this.supclick();
        }
      }
    }
  }
</script>

<style scoped>
  .gissty {
    width: 100%;
    height: -webkit-calc(100% - 20px);
    height: -moz-calc(100% - 20px);
    height: calc(100% - 20px);
    padding: 10px 0px 10px 0px;
    position: relative;
  }

  .maps {
    width: 100%;
    height: 100%;
  }

  .mapa {
    width: 100%;
    height: 100%;
  }

  .mapsbox {
    -webkit-box-shadow: 0px 0px 10px rgb(40, 167, 239);
    box-shadow: 0px 0px 10px rgb(40, 167, 239);
  }

  .mpaQuery {
    position: absolute;
    width: 200px;
    right: 20px;
    top: 20px;
    z-index: 500;
  }

  .tcxx {
    position: absolute;
    bottom: 40px;
    right: 20px;
    width: 200px;
    min-height: 120px;
    border-radius: 4px;
    float: right;
    margin-left: 10px;
    background: #fff;
    z-index: 1000;
  }

  .tctit {
    width: 100%;
    height: 30px;
    background: -webkit-linear-gradient(to left, #4089d9, #3564e1);
    /* Safari 5.1-6.0 */
    background: -o-linear-gradient(to left, #4089d9, #3564e1);
    /* Opera 11.1-12.0 */
    background: -moz-linear-gradient(to left, #4089d9, #3564e1);
    /* Firefox 3.6-15 */
    background: linear-gradient(to left, #4089d9, #3564e1);
    /* 标准语法 */
  }

  .titname {
    width: 50%;
    line-height: 14px;
    padding-left: 10px;
    border-left: 3px solid #fff;
    font-size: 12px;
    float: left;
    margin-left: 10px;
    margin-top: 8px;
    color: #fff;
  }

  .gb {
    float: right;
    font-size: 14px;
    line-height: 30px;
    margin-right: 10px;
    color: #fff;
    cursor: pointer;
  }

  .checkboxs {
    width: 96%;
    padding-left: 2%;
    padding-right: 2%;
  }

  .tccheckbox {
    width: 50%;
    float: left;
    margin: 0;
  }
</style>
